import React from 'react';
import PropTypes from 'prop-types';

import { SOCIAL_PROVIDERS } from 'v1/helpers/DropdownDataSets';
import { recognizePlatform, socialResolvers } from 'v1/helpers/socialResolvers';
import TypeTextInput from 'v1/components/shared/byType/text/TextInput/__types__/TypeTextInput';
import { TextInputGroup } from 'v1/components/shared';

// NOTE: Currently we only use this with an object with keys of value_1 & value_2 - can easily be adapted
const SocialInput = ({ value, onBlur, onChange, ...props }) => {
  const platform = value?.value_2?.toLowerCase().trim() || 'other';
  const parsedResult = (
    socialResolvers[platform] || socialResolvers.other
  ).parseInput(value.value_1 || '');

  const parseValue = value => {
    const recognizedPlatform = recognizePlatform(
      value.value_1 || '',
      value.value_2
    );
    if (recognizedPlatform) {
      return { ...value, value_2: recognizedPlatform.platform };
    }
    return value;
  };

  const handleSourceChange = (value, source) => {
    if (source === 'input') {
      onChange?.(parseValue(value));
    } else {
      onChange?.(value);
    }
  };

  const handleSourceBlur = (value, key, source) => {
    if (source === 'input') {
      onBlur?.(parseValue(value), key);
    } else {
      onBlur?.(value, key);
    }
  };

  // Use richHandle when available, fallback to handle
  const overlayLabel =
    parsedResult?.richHandle ?? parsedResult?.handle ?? value?.value_1;

  return (
    <TextInputGroup
      type="url"
      placeholder="Handle"
      value={value}
      valueKey="value_1"
      prepend={{
        valueKey: 'value_2',
        options: SOCIAL_PROVIDERS
      }}
      overlayLabel={overlayLabel}
      overlayAction={parsedResult?.fullUrl}
      onSourceChange={handleSourceChange}
      onSourceBlur={handleSourceBlur}
      {...props}
    />
  );
};

SocialInput.propTypes = {
  ...TypeTextInput,
  value: PropTypes.shape({
    value_1: PropTypes.string,
    value_2: PropTypes.string
  }),
  onBlur: PropTypes.func,
  onChange: PropTypes.func
  // Inherits standard UrlInput, TextInput & HTML input properties
};

export default SocialInput;
